'use strict';

import { BaseController } from '../../../base/controller';

export class RadioAccordionSectionController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({controllerService});
  }

  $onInit() {
    if (this.isOpen) {
      this.broadcastOpened();
    }
  }

  checkIfOpen($event) {
    if (this.isOpen) {
      $event.preventDefault();
      $event.stopPropagation();
      return;
    }
    this.broadcastOpened();
  }

  broadcastOpened() {
    if (angular.isFunction(this.onOpen)) {
      this.onOpen();
    }
  }
}
